// extracted by mini-css-extract-plugin
export default {"radioGroup":"question_radioGroup__oL9Ac","radioButton":"question_radioButton__8i6Xo","selected":"question_selected__utaaK"};